import { createFileRoute } from '@tanstack/react-router';
import { TenantSettingsPage } from '@/features/tenant/pages/tenant-settings-page';

export const Route = createFileRoute('/_app/settings/tenant')({ component: TenantSettingsPage });
